function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import SelectedGenerators from 'js/containers/legacy/SelectedGenerators';
export var CLEAR_ICON_SVG = require('images/delete.svg');
var CLEAR_BUTTON_TEXT = 'Clear'; // TODO: Alex's localization

var SelectedGeneratorsDesktop =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectedGeneratorsDesktop, _React$Component);

  function SelectedGeneratorsDesktop() {
    _classCallCheck(this, SelectedGeneratorsDesktop);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectedGeneratorsDesktop).apply(this, arguments));
  }

  _createClass(SelectedGeneratorsDesktop, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "col-sm-4 col-md-3"
      }, this.props.children, React.createElement("div", {
        className: "cndc-checkbox-list-and-button-wrapper"
      }, React.createElement(SelectedGenerators, {
        plotId: this.props.plotId
      }), React.createElement("button", {
        className: "cndc-checkbox-list__clear-button",
        onClick: this.props.plotClearGenerators
      }, React.createElement("img", {
        className: "cndc-checkbox-list__clear-button__icon",
        alt: CLEAR_BUTTON_TEXT,
        src: CLEAR_ICON_SVG
      }), React.createElement("span", {
        className: "cndc-checkbox-list__clear-button__text"
      }, CLEAR_BUTTON_TEXT))));
    }
  }]);

  return SelectedGeneratorsDesktop;
}(React.Component);

SelectedGeneratorsDesktop.propTypes = {
  plotClearGenerators: PropTypes.func.isRequired,
  plotId: PropTypes.string.isRequired,
  children: PropTypes.node
};
export { SelectedGeneratorsDesktop as default };